import { useLocation } from 'react-router-dom'
import { Container, Tab, Tabs } from '@mui/material'
import { useState } from 'react'
import Header from '../../components/Header'
import SignIn from './SignIn'
import SignUp from './SignUp'

const Login: React.FC = () => {
  const location = useLocation()
  const location_state = location.state as {from: string} | undefined
  const [sign_type, setSignType] = useState<'sign_up' | 'sign_in'>('sign_in')
  const from = location_state?.from || '/'

  return <>
    <Header/>

    <main>
      <Container maxWidth='md'>
        <Tabs
          value={sign_type}
          onChange={(_, new_value)=> { setSignType(new_value) }}
          variant='fullWidth'
        >
          <Tab label='ログイン' value='sign_in'/>
          <Tab label='新規登録' value='sign_up'/>
        </Tabs>

        {sign_type === 'sign_in' ? <SignIn from={from}/> : <SignUp from={from}/>}
      </Container>
    </main>
  </>
}
export default Login
